import { inject, type InjectionKey } from "vue"
import type { UploadEditSession } from "./useUploadEditSession"

export const UploadEditSessionKey: InjectionKey<UploadEditSession> = Symbol("UploadEditSession")

export function useUploadEditSessionContext(): UploadEditSession {
  const session = inject(UploadEditSessionKey)
  if (!session) {
    throw new Error("UploadEditSession not provided — must be used inside <UploadDialog>")
  }
  return session
}
